import { ActionsUnion, createAction } from 'spw-redux/types';
import { GetProjectsParams, ProjectSlimForList } from '../projects/types';
import {
  UpdateTeamFields,
  TeamDetailVM,
  TeamForm,
  TeamListItemVM,
  TeamSlim,
  TeamsSortParams,
  ITeamsState,
  GetUsersInTeamParams,
  TeamMemberListVM,
  TeamSortOptions,
} from './types';

export const GET_TEAM = 'teams/GET_TEAM';
export const GET_TEAM_SUCCEEDED = 'teams/GET_TEAM_SUCCEEDED';
export const GET_TEAM_FAILED = 'teams/GET_TEAM_FAILED';

export const GET_TEAMS = 'teams/GET_TEAMS';
export const GET_TEAMS_SUCCEEDED = 'teams/GET_TEAMS_SUCCEEDED';
export const GET_TEAMS_FAILED = 'teams/GET_TEAMS_FAILED';

export const CREATE_TEAM = 'teams/CREATE_TEAM';
export const CREATE_TEAM_FAILED = 'teams/CREATE_TEAM_FAILED';

export const UPDATE_TEAM = 'teams/UPDATE_TEAM';
export const UPDATE_TEAM_SUCCEEDED = 'teams/UPDATE_TEAM_SUCCEEDED';
export const UPDATE_TEAM_FAILED = 'teams/UPDATE_TEAM_FAILED';

export const DELETE_TEAM = 'teams/DELETE_TEAM';

export const ADD_USER_TO_TEAMS = 'teams/ADD_USER_TO_TEAMS';

export const ADD_USERS_TO_TEAM = 'teams/ADD_USERS_TO_TEAM';

export const REMOVE_USER_FROM_TEAM = 'teams/REMOVE_USER_FROM_TEAM';

export const JOIN_TEAM = 'teams/JOIN_TEAM';

export const LEAVE_TEAM = 'teams/LEAVE_TEAM';

export const ISSUE_REQUEST_TO_JOIN_TEAM = 'teams/ISSUE_REQUEST_TO_JOIN_TEAM';
export const ISSUE_REQUEST_TO_JOIN_TEAM_SUCCEEDED =
  'teams/ISSUE_REQUEST_TO_JOIN_TEAM_SUCCEEDED';
export const ISSUE_REQUEST_TO_JOIN_TEAM_FAILED =
  'teams/ISSUE_REQUEST_TO_JOIN_TEAM_FAILED';

export const GET_TEAMS_FOR_PROJECT = 'teams/GET_TEAMS_FOR_PROJECT';
export const GET_TEAMS_FOR_PROJECT_SUCCEEDED =
  'teams/GET_TEAMS_FOR_PROJECT_SUCCEEDED';
export const GET_TEAMS_FOR_PROJECT_FAILED =
  'teams/GET_TEAMS_FOR_PROJECT_FAILED';

export const GET_PROJECTS_FOR_TEAM = 'teams/GET_PROJECTS_FOR_TEAM';
export const GET_PROJECTS_FOR_TEAM_SUCCEEDED =
  'teams/GET_PROJECTS_FOR_TEAM_SUCCEEDED';
export const GET_PROJECTS_FOR_TEAM_FAILED =
  'teams/GET_PROJECTS_FOR_TEAM_FAILED';

export const GET_USERS_IN_TEAM = 'teams/GET_USERS_IN_TEAM';
export const GET_USERS_IN_TEAM_SUCCEEDED = 'teams/GET_USERS_IN_TEAM_SUCCEEDED';

export const GET_TEAMS_FOR_POPOVER = 'teams/GET_TEAMS_FOR_POPOVER';
export const GET_TEAMS_FOR_POPOVER_SUCCEEDED =
  'teams/GET_TEAMS_FOR_POPOVER_SUCCEEDED';

export const CLEAR_TEAMS_REDUCER_BY_KEY = 'teams/CLEAR_TEAMS_REDUCER_BY_KEY';

export const getTeam = (id: number) => createAction(GET_TEAM, { id });
export const getTeamSucceeded = (team: TeamDetailVM) =>
  createAction(GET_TEAM_SUCCEEDED, { team });
export const getTeamFailed = () => createAction(GET_TEAM_FAILED);

export const getTeams = (params?: TeamsSortParams) =>
  createAction(GET_TEAMS, params);
export const getTeamsSucceeded = (results: {
  teams: TeamListItemVM[];
  total: number;
  shouldAppend: boolean;
}) => createAction(GET_TEAMS_SUCCEEDED, results);
export const getTeamsFailed = () => createAction(GET_TEAMS_FAILED);

export const getTeamsForProject = (payload: {
  projectId: number;
  page?: number;
  perPage?: number;
  sort: TeamSortOptions;
}) => createAction(GET_TEAMS_FOR_PROJECT, payload);
export const getTeamsForProjectSucceeded = (results: {
  total: number;
  teams: TeamListItemVM[];
}) => createAction(GET_TEAMS_FOR_PROJECT_SUCCEEDED, results);
export const getTeamsForProjectFailed = () =>
  createAction(GET_TEAMS_FOR_PROJECT_FAILED);

export const getProjectsForTeam = (
  teamId: number,
  params?: GetProjectsParams
) => createAction(GET_PROJECTS_FOR_TEAM, { teamId, params });
export const getProjectsForTeamSucceeded = (
  results: { total: number; projects: ProjectSlimForList[] },
  shouldAppend: boolean
) =>
  createAction(GET_PROJECTS_FOR_TEAM_SUCCEEDED, { ...results, shouldAppend });
export const getProjectsForTeamFailed = () =>
  createAction(GET_PROJECTS_FOR_TEAM_FAILED);

export const getTeamsForPopover = (userId?: number, clientId?: number) =>
  createAction(GET_TEAMS_FOR_POPOVER, { userId, clientId });
export const getTeamsForPopoverSucceeded = (teams: TeamSlim[]) =>
  createAction(GET_TEAMS_FOR_POPOVER_SUCCEEDED, teams);

export const addUserToTeams = (userId: number, teamIds: number[]) =>
  createAction(ADD_USER_TO_TEAMS, { userId, teamIds });

export const addUsersToTeam = (params: {
  userIds: number[];
  teamId: number;
  onSuccess: () => void;
}) => createAction(ADD_USERS_TO_TEAM, params);

export const removeUserFromTeam = (params: {
  userId: number;
  teamId: number;
  onSuccess: () => void;
}) => createAction(REMOVE_USER_FROM_TEAM, params);

export const createTeam = (params: {
  form: TeamForm;
  onSuccess: (id: number) => void;
}) => createAction(CREATE_TEAM, params);
export const createTeamFailed = (becauseNameTaken: boolean) =>
  createAction(CREATE_TEAM_FAILED, { becauseNameTaken });

export const updateTeam = (params: {
  form: UpdateTeamFields;
  onSuccess?: () => void;
}) => createAction(UPDATE_TEAM, params);
export const updateTeamSucceeded = (team: TeamDetailVM) =>
  createAction(UPDATE_TEAM_SUCCEEDED, { team });
export const updateTeamFailed = (becauseNameTaken: boolean) =>
  createAction(UPDATE_TEAM_FAILED, { becauseNameTaken });

export const deleteTeam = (params: { id: number; onSuccess?: () => void }) =>
  createAction(DELETE_TEAM, params);

export const joinTeam = (params: { id: number; onSuccess?: () => void }) =>
  createAction(JOIN_TEAM, params);

export const leaveTeam = (params: { id: number; onSuccess?: () => void }) =>
  createAction(LEAVE_TEAM, params);

export const issueRequestToJoinTeam = (params: {
  id: number;
  onSuccess?: () => void;
}) => createAction(ISSUE_REQUEST_TO_JOIN_TEAM, params);
export const issueRequestToJoinTeamSucceeded = () =>
  createAction(ISSUE_REQUEST_TO_JOIN_TEAM_SUCCEEDED);
export const issueRequestToJoinTeamFailed = () =>
  createAction(ISSUE_REQUEST_TO_JOIN_TEAM_FAILED);

export const getUsersInTeam = (params: GetUsersInTeamParams) =>
  createAction(GET_USERS_IN_TEAM, params);

export const getUsersInTeamSucceeded = (results: {
  users: TeamMemberListVM[];
  shouldAppend: boolean;
  total: number;
}) => createAction(GET_USERS_IN_TEAM_SUCCEEDED, results);

export const clearTeamsReducerByKey = (key: keyof ITeamsState) =>
  createAction(CLEAR_TEAMS_REDUCER_BY_KEY, key);

export const actionNames = {
  GET_TEAMS,
  GET_TEAMS_SUCCEEDED,
  GET_TEAMS_FAILED,
  CREATE_TEAM,
  CREATE_TEAM_FAILED,
  UPDATE_TEAM,
  UPDATE_TEAM_SUCCEEDED,
  UPDATE_TEAM_FAILED,
  DELETE_TEAM,
  ADD_USER_TO_TEAMS,
  ADD_USERS_TO_TEAM,
  REMOVE_USER_FROM_TEAM,
  JOIN_TEAM,
  ISSUE_REQUEST_TO_JOIN_TEAM,
  ISSUE_REQUEST_TO_JOIN_TEAM_SUCCEEDED,
  ISSUE_REQUEST_TO_JOIN_TEAM_FAILED,
  LEAVE_TEAM,
  GET_TEAM,
  GET_TEAM_SUCCEEDED,
  GET_TEAM_FAILED,
  GET_TEAMS_FOR_PROJECT,
  GET_TEAMS_FOR_PROJECT_FAILED,
  GET_TEAMS_FOR_PROJECT_SUCCEEDED,
  GET_PROJECTS_FOR_TEAM,
  GET_PROJECTS_FOR_TEAM_SUCCEEDED,
  GET_PROJECTS_FOR_TEAM_FAILED,
  GET_TEAMS_FOR_POPOVER,
  GET_TEAMS_FOR_POPOVER_SUCCEEDED,
  GET_USERS_IN_TEAM,
  GET_USERS_IN_TEAM_SUCCEEDED,
  CLEAR_TEAMS_REDUCER_BY_KEY,
};

export const actions = {
  getTeam,
  getTeamSucceeded,
  getTeamFailed,
  getTeams,
  getTeamsSucceeded,
  getTeamsFailed,
  createTeam,
  createTeamFailed,
  updateTeam,
  updateTeamSucceeded,
  updateTeamFailed,
  deleteTeam,
  addUserToTeams,
  addUsersToTeam,
  removeUserFromTeam,
  joinTeam,
  issueRequestToJoinTeam,
  issueRequestToJoinTeamSucceeded,
  issueRequestToJoinTeamFailed,
  getTeamsForProject,
  getTeamsForProjectFailed,
  getTeamsForProjectSucceeded,
  getProjectsForTeam,
  getProjectsForTeamFailed,
  getProjectsForTeamSucceeded,
  getTeamsForPopover,
  getTeamsForPopoverSucceeded,
  leaveTeam,
  getUsersInTeam,
  getUsersInTeamSucceeded,
  clearTeamsReducerByKey,
};

export type Actions = ActionsUnion<typeof actions>;
